import { useCallback } from "react";
import cn from "classnames";
import { useUserDesign } from "@/states/design.state";
import { useConfig, useGenerateResult } from "@/states/common.state";
import useGenerateHomeQr from "@/components/page-modules/home-page/hooks/useGenerateHomeQr";
import { useIsloading } from "@/states/ui.state";
import Image from "next/image";
import { useMediaQuery } from "react-responsive";
import { STICKER_LIST } from "@/constant/sticker.repo";
import style from "./Sticker.module.scss";
import { customizeCdnLink } from "@/helper/customize.helper";
const Sticker: React.FC = () => {
  const {
    sticker,
    setSticker
  } = useUserDesign();
  const {
    result
  } = useGenerateResult();
  const {
    setIsloading
  } = useIsloading();
  const isMobile = useMediaQuery({
    maxWidth: 600
  });
  const {
    payload,
    config,
    files,
    setConfig
  } = useConfig();
  const {
    mutateHomeQr,
    mutateLoading
  } = useGenerateHomeQr(false);
  const handleStickerSelection = useCallback((key: string) => {
    setSticker(key);
    setIsloading(true);
    const newConfig = {
      ...config,
      sticker: key
    };
    setConfig(newConfig);
    if (!mutateLoading || !result) {
      mutateHomeQr({
        params: {
          ...payload,
          files
        },
        configParams: newConfig
      });
    }
  }, [setSticker, setIsloading, result, mutateLoading, mutateHomeQr]);
  const renderStickers = useCallback((stickers: {
    key: string;
    value?: string;
  }[]) => stickers.map(({
    key,
    value
  }, index) => <button key={index} disabled={key === sticker} className={cn(style.item, {
    [style.active]: key === (sticker || "none")
  })} onClick={() => handleStickerSelection(key)} aria-label={`sticker-${key}`}>
                    <Image src={value || `${customizeCdnLink("stickers", key)}`} alt={key} fill />
                </button>), [sticker, handleStickerSelection]);
  return <div data-sentry-component="Sticker" data-sentry-source-file="Sticker.tsx">
            <div className={style.flex}>
                {renderStickers([{
        key: "none"
      }, ...STICKER_LIST.filter(sticker => isMobile ? sticker.is_mobile : sticker.guest === undefined)])}
            </div>
        </div>;
};
export default Sticker;